module.exports = __webpack_public_path__ + "static/media/digital_change_demo.b0bdd3cf.png";